import { ProjectResponse, usePutApiProjectsByProjectIdFoldersAndSourceFolderIdCopyMutation } from "api/generatedApi";
import { useDialog } from "shared/dialog/use-dialog";
import { ResultDialogType, useMutation } from "utils/hooks/use-mutation";
import { useTranslation } from "react-i18next";
import { ExtendedProjectFolder } from "pages/project/hooks/use-map-tree-to-flat";
import { FolderCopy } from "../copy";

interface Props {
  sourceProject: ProjectResponse;
  destinationProject: ProjectResponse;
  selectedFolder: ExtendedProjectFolder | undefined;
  dataFlatlist: ExtendedProjectFolder[];
  crossProjectCopy: boolean;
}

//Accept a ref that contains the current props
export function useCopyFolder(propsRef: React.MutableRefObject<Props>) {
  const { t } = useTranslation();

  const [openCopyFolderDialog, closeCopyFolderDialog] = useDialog(FolderCopy);
  const [copyFolder] = usePutApiProjectsByProjectIdFoldersAndSourceFolderIdCopyMutation();

  const wrapMutation = useMutation({
    onSuccess: closeCopyFolderDialog,
    successProps: {
      description: t("folder.copy.success.description"),
    },
    resultDialogType: ResultDialogType.Toast,
  });

  const handleOnSubmit = (destinationFolderId: string, destinationProjectId: string, setAmountsToZero: boolean) => {
    //Use current props from ref
    const currentProps = propsRef.current;
    wrapMutation(
      copyFolder({
        projectId: currentProps.sourceProject.projectId ? currentProps.sourceProject.projectId : "",
        sourceFolderId: currentProps.selectedFolder?.projectFolderId ? currentProps.selectedFolder.projectFolderId : "",
        copyProjectFolderRequest: {
          destinationFolderId: destinationFolderId,
          destinationProjectId: destinationProjectId,
          setAmountsToZero: setAmountsToZero,
        },
      })
    );
  };

  const handleClick = () => {
    //Get current props from ref at execution time
    const currentProps = propsRef.current;

    openCopyFolderDialog({
      projectDestination: currentProps.destinationProject,
      dataFlatlist: currentProps.dataFlatlist,
      selectedFolder: currentProps.selectedFolder,
      onSubmit: handleOnSubmit,
      crossProjectCopy: currentProps.crossProjectCopy,
    });
  };

  return handleClick;
}
